import { JDSBadgeProps } from './generated/interface';

export const modifyIcon = ({ kind, icon }: JDSBadgeProps) => {
  if (kind !== 'service') return icon;

  // TODO: Update logic to check component name
  return typeof icon !== 'string' || icon?.includes('Ps') ? icon : undefined;
};

export const withLogic =
  (Component: React.ComponentType<JDSBadgeProps>): React.FC<JDSBadgeProps> =>
  (props: JDSBadgeProps) => {
    return <Component {...props} icon={modifyIcon(props)} />;
  };
